import { UserProvider } from '@/context/UserContext';
import MemeSocketProvider from '@/provider/MemeSocketProvider';
import { ModalProvider } from '@/provider/ModalProvider';
import SocketProvider from '@/provider/SocketProvider';
import { SolanaWalletProvider } from '@/provider/SolanaWalletProvider';
import { MsgInfo, UserInfo } from '@/utils/types';
import 'dotenv/config.js';
import { ReactNode, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import {
  QueryClient as QueryClientTanstack,
  QueryClientProvider as QueryClientProviderTanstack,
} from '@tanstack/react-query';
import { ToastContainer } from 'react-toastify';
import { createConfig, WagmiProvider } from 'wagmi';
import { mainnet, sepolia } from 'wagmi/chains';
import { metaMaskWallet } from '@rainbow-me/rainbowkit/wallets';
import { connectorsForWallets } from '@rainbow-me/rainbowkit';

const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [metaMaskWallet],
    },
  ],
  {
    appName: 'Distill-Demo',
    projectId: '2ac779892f366ccc0af6a8d986ab6d86',
  },
);
//@ts-ignore
export const wagmiConfig = createConfig({
  connectors,
  chains: [mainnet, sepolia],
});

export const queryClient = new QueryClient();
const queryClientTanstack = new QueryClientTanstack();

export default function Providers({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<UserInfo>({} as UserInfo);
  const [login, setLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('/*.png');
  const [messages, setMessages] = useState<MsgInfo[]>([]);
  const [coinId, setCoinId] = useState<string>('');
  const [newMsg, setNewMsg] = useState<MsgInfo>({} as MsgInfo);
  const [solPrice, setSolPrice] = useState<number>(0);
  const [oraiPrice, setOraiPrice] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(0);
  const [profileEditModal, setProfileEditModal] = useState<boolean>(false);
  const [postReplyModal, setPostReplyModal] = useState<boolean>(false);

  return (
    <SolanaWalletProvider>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProviderTanstack client={queryClientTanstack}>
          <QueryClientProvider client={queryClient}>
            <ModalProvider>
              <UserProvider
                value={{
                  solPrice,
                  setSolPrice,
                  oraiPrice,
                  setOraiPrice,
                  maxPrice,
                  setMaxPrice,
                  newMsg,
                  setNewMsg,
                  coinId,
                  setCoinId,
                  messages,
                  setMessages,
                  imageUrl,
                  setImageUrl,
                  user,
                  setUser,
                  login,
                  setLogin,
                  isLoading,
                  setIsLoading,
                  profileEditModal,
                  setProfileEditModal,
                  postReplyModal,
                  setPostReplyModal,
                }}
              >
                <SocketProvider>
                  <MemeSocketProvider>{children}</MemeSocketProvider>
                </SocketProvider>
                <ToastContainer pauseOnFocusLoss={false} theme="colored" />
              </UserProvider>
            </ModalProvider>
          </QueryClientProvider>
        </QueryClientProviderTanstack>
      </WagmiProvider>
    </SolanaWalletProvider>
  );
}
